import './App.css';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { Dock, DockIcon, DockItem, DockLabel } from './components/Dock';
import { HomeIcon, AboutIcon, ContactIcon, NewsIcon } from './components/Icons';
import About from './pages/About';
import Contact from './pages/Contact';
import News from './pages/News';
import Spline from '@splinetool/react-spline';

function HomePage() {
  return (
    <header className="App-header relative">
      <div className="container mx-auto px-4">
        <h1>Hubble Heavy Industries Inc.</h1>
      </div>
    </header>
  );
}

function AppContent() {
  const navigate = useNavigate();

  return (
    <div className="App relative h-screen overflow-hidden">
      <div className="absolute inset-0 z-0" style={{ height: '108vh' }}>
        <Spline 
          scene="https://prod.spline.design/N9I0mn17GF1ve0N4/scene.splinecode"
          style={{ width: '100%', height: '100%' }}
        />
      </div>
      
      <div className="relative z-10">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/news" element={<News />} />
        </Routes>
      </div>

      <Dock>
        <DockItem onClick={() => navigate('/')}>
          <DockIcon>
            <HomeIcon />
          </DockIcon>
          <DockLabel>Home</DockLabel>
        </DockItem>
        
        <DockItem onClick={() => navigate('/about')}>
          <DockIcon>
            <AboutIcon />
          </DockIcon>
          <DockLabel>About</DockLabel>
        </DockItem>
        
        <DockItem onClick={() => navigate('/news')}>
          <DockIcon>
            <NewsIcon />
          </DockIcon>
          <DockLabel>News</DockLabel>
        </DockItem>

        <DockItem onClick={() => navigate('/contact')}>
          <DockIcon>
            <ContactIcon />
          </DockIcon>
          <DockLabel>Contact</DockLabel>
        </DockItem>
      </Dock>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
